module.exports = __webpack_public_path__ + "static/vf_wshorts_core.ee787ccd.svg";